export default __webpack_public_path__ + "static/media/amex-inverted_82041.853517e0.png";